import {useRef} from 'react';
import {Modal} from '@cvent/carina/components/Modal';
import {Button} from '@cvent/carina/components/Button';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';

type CancelScheduledChangeModalProps = {
  handleClose: () => void;
  onConfirm: () => void;
  currentPlanDisplayName: string;
};

const CancelScheduledChangeModal = ({
  handleClose,
  onConfirm,
  currentPlanDisplayName,
}: CancelScheduledChangeModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  return (
    <Modal
      isOpen
      format="md"
      onDismiss={handleClose}
      testID="cancel-scheduled-change-modal"
      aria-labelledby="cancel-scheduled-change-title"
    >
      <div className="flex flex-col box-border p-6 pt-4">
        <div className="mb-4 flex items-start justify-between">
          <h1
            id="cancel-scheduled-change-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[length:var(--carina-font-size-display-xs)] font-[var(--carina-font-weight-display)] leading-[var(--carina-line-height-display-xs)] pt-1"
          >
            {`Would you like to keep your ${currentPlanDisplayName} plan?`}
          </h1>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>
        <div className="mt-4 flex justify-end gap-4">
          <Button
            text="Cancel"
            onClick={handleClose}
            type="button"
            appearance="lined"
          />
          <Button
            text="Keep plan"
            onClick={onConfirm}
            type="button"
            appearance="filled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default CancelScheduledChangeModal;
